import { FaChevronDown } from "react-icons/fa6";

const Requirements = () => {
  return (
    <div className="custom-container lg:pb-[141px] md:pb-[100px] sm:pb-[50px] pb-[30px]">
      <div className="flex font-[Rockwell] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold ">
        <span className="underline  lg:decoration-[8px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] decoration-[#7ABF5B]">
          DEALER
          <span className="underline  lg:decoration-[8px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] !decoration-[#fff]">
            {" "}
            REQUIREMENTS
          </span>
        </span>
      </div>
      <div className="font-[Roboto] font-bold 2xl:text-[36px] 2xl:text-[46px] xl:text-[40px] lg:text-[35px] text-[23px]px] text-[16px] mt-[36px]">
        Qualified dealers must be able to market and service Tuatara Products in their given territory. Requirements
        (exceptions made on a case-by-case basis):
      </div>
      <div className="lg:mt-[78px] md:mt-[68px] sm:mt-[58px] mt-[38px]">
        <div className="border-[2px] border-[#000] md:px-[47px] px-[17px] bg-[#F2F2F2]  md:py-[34px] py-[10px] flex">
          <div className="w-[44px]">
            <FaChevronDown className="!text-[#7ABF5B] !text-[44px]" />
          </div>
          <div className="lg:ml-[60px] md:ml-[50px] sm:ml-[30px] ml-[20px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] font-extrabold">
            SALES EXPERIENCE AND STRATEGY
          </div>
        </div>
        <div className="border-[2px] border-[#000] md:px-[47px] px-[17px] bg-[#F2F2F2]  md:py-[34px] py-[10px] flex">
          <div className="w-[44px]">
            <FaChevronDown className="!text-[#7ABF5B] !text-[44px]" />
          </div>
          <div className="lg:ml-[60px] md:ml-[50px] sm:ml-[30px] ml-[20px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] font-extrabold">
            BUSINESS CREDIT LINE
          </div>
        </div>
        <div className="border-[2px] border-[#000] md:px-[47px] px-[17px] bg-[#F2F2F2]  md:py-[34px] py-[10px] flex">
          <div className="w-[44px]">
            <FaChevronDown className="!text-[#7ABF5B] !text-[44px]" />
          </div>
          <div className="lg:ml-[60px] md:ml-[50px] sm:ml-[30px] ml-[20px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] font-extrabold">
            INITIAL ORDER
          </div>
        </div>
        <div className="border-[2px] border-[#000] md:px-[47px] px-[17px] bg-[#F2F2F2]  md:py-[34px] py-[10px] flex">
          <div className="w-[44px]">
            <FaChevronDown className="!text-[#7ABF5B] !text-[44px]" />
          </div>
          <div className="lg:ml-[60px] md:ml-[50px] sm:ml-[30px] ml-[20px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] font-extrabold">
            ANNUAL SALES
          </div>
        </div>
        <div className="border-[2px] border-[#000] md:px-[47px] px-[17px] bg-[#F2F2F2]  md:py-[34px] py-[10px] flex">
          <div className="w-[44px]">
            <FaChevronDown className="!text-[#7ABF5B] !text-[44px]" />
          </div>
          <div className="lg:ml-[60px] md:ml-[50px] sm:ml-[30px] ml-[20px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] font-extrabold">
            PARTS AND SERVICE
          </div>
        </div>
        <div className="border-[2px] border-[#000] md:px-[47px] px-[17px] bg-[#F2F2F2]  md:py-[34px] py-[10px] flex">
          <div className="w-[44px]">
            <FaChevronDown className="!text-[#7ABF5B] !text-[44px]" />
          </div>
          <div className="lg:ml-[60px] md:ml-[50px] sm:ml-[30px] ml-[20px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] font-extrabold">
            ONGOING SERVICE & MAINTENANCE
          </div>
        </div>
      </div>
    </div>
  );
};
export default Requirements;
